module.exports = __webpack_public_path__ + "static/media/stefkovic.c92de8eb.jpg";